module.exports = {"areas":[{"filter":"produktentwicklung","label":"Produktentwicklung"},{"filter":"beschaffung","label":"Beschaffung und Einkauf"},{"filter":"planung-steuerung","label":"Planung und Steuerung von Produktionsabläufen"},{"filter":"marketing","label":"Marketing"},{"filter":"vertrieb","label":"Vertrieb"},{"filter":"logistik","label":"Logistik"},{"filter":"innerbetriebliche-verwaltung","label":"Innerbetriebliche Verwaltung"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/company/kirc/data/filters.json
// module id = 3p1l
// module chunks = 1